import React, { useCallback, useEffect, useState } from 'react'
import { Box } from '@material-ui/core'
import clsx from 'clsx'

import { ChatActions, ChatHeader, ChatMessages } from './components'

import useDaiChat from 'hooks/useDaiChat'

import styles from './styles'

const DaiChat = ({
  chatSize = 'small',
  messageContainerProps = {},
  fixedHeight,
  variant = 'default',
  ...rest
}) => {
  const isDefaultVariant = variant === 'default'

  const useStyles = styles(isDefaultVariant)
  const classes = useStyles()
  const { messages, loading, messagesContainerRef, chatContainerRef } =
    useDaiChat()

  const [showTopShadow, setShowTopShadow] = useState(false)
  const [showBottomShadow, setShowBottomShadow] = useState(false)

  const updateShadows = useCallback(() => {
    const container = messagesContainerRef.current
    if (!container) return

    setShowTopShadow(container.scrollTop > 0)
    const distanceFromBottom =
      container.scrollHeight - container.scrollTop - container.clientHeight
    setShowBottomShadow(distanceFromBottom > 8)
  }, [messagesContainerRef])

  useEffect(() => {
    const container = messagesContainerRef.current
    if (!container) return

    updateShadows()
    container.addEventListener('scroll', updateShadows)
    return () => container.removeEventListener('scroll', updateShadows)
  }, [messages, loading, chatSize, messagesContainerRef, updateShadows])

  return (
    <Box
      {...rest}
      ref={chatContainerRef}
      className={clsx(
        classes.chatContainer,
        {
          [classes.defaultVariant]: isDefaultVariant,
          [classes.paperVariant]: !isDefaultVariant,
        },
        rest?.className,
      )}
    >
      <Box className={classes.chatContent}>
        <Box className={classes.chatHeader}>
          <ChatHeader chatSize={chatSize} />
        </Box>

        <Box pb={2} display="flex" flex={1} minHeight={0}>
          <Box
            className={clsx(classes.messagesContainer, {
              [classes.topTransitionEffect]: showTopShadow,
              [classes.bottomTransitionEffect]: showBottomShadow,
            })}
          >
            <ChatMessages
              fixedHeight={fixedHeight}
              {...messageContainerProps}
            />
          </Box>
        </Box>

        <Box className={classes.chatActions}>
          {/* Implementação futura */}
          {/* <ChatHITL /> */}
          <ChatActions />
        </Box>
      </Box>
    </Box>
  )
}

export default DaiChat
